import GoldenRaceHandler from "./helpers/golden-race";
import LotoHandler from "./helpers/loto-handler";

export const ThirdPartyGameEnum = {
    MadnessSweepstakes: 57,
    Madness: 1450,
    Lucky6: 400031666,
    Predictor: 371,
    Loto: 112001,
    BookOf6: 112002,
    LuckyWheel: 112003,
    Bile: 112004,
    Lottery: 42078,
    BetTVGames: 9002,
    GoldenRace: 400002,
    RocketJet: 112005,
};

export const thirdPartyGamesConfig = {
    [ThirdPartyGameEnum.Lucky6]: { hasSecondScreen: true, tableId: 2101, limitgroupId: 1 },
    [ThirdPartyGameEnum.BookOf6]: { Handler: LotoHandler },
    [ThirdPartyGameEnum.Loto]: { Handler: LotoHandler },
    [ThirdPartyGameEnum.RocketJet]: { Handler: LotoHandler },
    [ThirdPartyGameEnum.GoldenRace]: { hasSecondScreen: true, Handler: GoldenRaceHandler },
};